import { AccountModel } from "@verivest/shared-components/src/api/models";
import { validateAllAttributesExistInData } from "./validateAllAttributesExistInData";
import { validateCustodianReqAttr } from "./validateCustodianReqAttr";

export const validateCustodiedAccReqAttr = (
  custodiedAcc: AccountModel | null | undefined,
) => {
  if (!custodiedAcc) {
    return false;
  }

  const custodiedAccountReqAttr: Array<keyof AccountModel> = [
    "nameOfRecord",
    "custodiedAccountType",
    "custodianAccountNumber",
    "isErisa",
  ];

  const isCustodiedAccountValid = validateAllAttributesExistInData(
    custodiedAccountReqAttr,
    custodiedAcc,
  );
  const isCustodianValid = validateCustodianReqAttr(custodiedAcc.custodian);

  return isCustodiedAccountValid && isCustodianValid;
};
